require('./bootstrap');

let http = require('./http');

export const initAdminScripts = function () {

    $('.email-terms-link').on('click', function() {
        let el = $(this);
        let buttonHtml = el.html();
        let loadingHtml = '<i class="fa fa-cog fa-spin fa-fw"></i>Sending...';
        let successHtml = '<i class="fa fa-thumbs-up"></i>Sent!';
        let failedHtml = '<i class="fa fa-thumbs-down"></i>Failed...';

        el.html(loadingHtml);

        let data = {
            clientId: el.data('client-id'),
            termsUrl: el.data('terms-link'),
        }

        http.sendAjax(window.location.href + '/emailTerms', 'POST', data,
            function() {
                el.html(successHtml)
            },
            function() {
                el.html(failedHtml)
            });
    });

    $(document).on('submit', 'form.create-user', function (el) {

        el.preventDefault();

        if (confirm('Are you sure you want to do this?')) {

            let button = $(this).find('.btn');
            button[0].disabled = true;
            button.html('<i class="fa fa-cog fa-spin"></i>');

            let form = $(this),
                url = form[0].action,
                method = form[0].method,
                data = new FormData(form[0]);

            form.attr('disabled', true);

            http.sendAjax(url, method, data, http.success, http.errors);
        }
    });

    $('form#client-evaluation-clinet-comments').on('submit', function(e) {

        e.preventDefault();

        let button = $(this).find('button');
        let buttonHtml = button.html();

        button[0].disabled = true;
        button.html('<i class="fa fa-cog fa-spin"></i> Saving...');

        let form = $(this),
            url = form[0].action,
            method = 'post',
            data = new FormData(form[0]);

        form.attr('disabled', true);

        let success = function(response, buttonHtml) {

            button.html(response.message);
            button[0].disabled = false;

            console.log(response.message);
        }

        http.sendAjax(url, method, data, success, http.errors);
    });

    $(document).on('click', '.trip-evaluation-action', function (e) {

        e.preventDefault();

        if (confirm('Are you sure you want to do this?')) {

            $(this).html('<i class="fa fa-cog fa-spin"></i>');
            let data = new FormData();

            if (!$.isEmptyObject($(this).data())) {
                let dataAttr = $(this).data();
                $.each(dataAttr, function (key, value) {
                    data.set(key, value);
                });
            }
            http.sendAjax($(this).data('href'), 'POST', data, http.success, http.errors);
        }

    });


    //Updates query params for filtering
    $(document).on('change', '.evaluationFilter', function () {

        let params = new URLSearchParams(location.search);

        if (location.search == '') {
            params.set($(this).attr('id'), $(this).val());
            window.location.replace(window.location.href + '?' + params);
        } else {
            if (params.get($(this).attr('id'))) {
                params.set($(this).attr('id'), $(this).val());
            } else {
                params.append($(this).attr('id'), $(this).val());
            }

            window.location.replace(location.protocol + '//' + location.host + location.pathname + "?" + params.toString());
        }
    });

    $(document).on('click', '.reset-evaluation-filters', function () {
        window.location.replace(location.protocol + '//' + location.host + location.pathname);
    });

    $(document).on('click', '.send-client-evaluation-email', function (e) {

        e.preventDefault();

        if (confirm('Are you sure you want to do this?')) {
            let button = $(this);
            let buttonHTML = $(this).html();

            $(this).html('<i class="fa fa-cog fa-spin"></i>');

            let data = new FormData();

            function success(response) {

                button.html(buttonHTML);

                if (response.hasOwnProperty('status') && response.hasOwnProperty('message')) {
                    alert(response.message);
                }
            }

            function errors(response) {
                window.location.reload();
            }

            http.sendAjax($(this).data('href'), 'POST', data, success, http.errors);
        }
    })

    $(function () {
        $('#sortable').sortable();
        $('.updateSort').sortable();
        $('#sortableList').sortable();
    });

    $('.updateSort').on('sortstop', function (event, ui) {

        let export_array = [];
        let url = $('.updateSort').first().data('route');
        let model = $('.updateSort').first().data('model');

        $('.ui-state-default').each(function (index, element) {
            let question = {};
            question.id = element.getAttribute('data-model-id');
            question.sort = index + 1;

            export_array.push(question);
        });

        let data = {
            data: export_array,
            model: model
        };

        let dataString = decodeURIComponent($.param(data))

        function success(response) {
            if (response.reload) {
                window.location = window.location;
            }
        }

        function error(response) {
            console.log(response);
        }

        $.post(url, dataString, success, 'json');
    });

    $('#sortableList').on('sortstop', function (event, ui) {
        let export_array = [];

        let url = $('#sortableList').data('route');
        let model = $('#sortableList').data('model');

        $('.ui-state-default').each(function (index, element) {
            let record = {};
            record.id = element.getAttribute('data-model-id');
            record.sort = index + 1;

            export_array.push(record);
        });

        let data = {
            data: export_array,
            model: model
        };

        let dataString = decodeURIComponent($.param(data))

        let loadingContainer = $(".loading-spinner-container").first();

        loadingContainer.toggle('hide');

        function success(response) {
            loadingContainer.toggle('hide')
            if (response.reload) {
                window.location = window.location;
            }
        }

        function error(response) {
            console.log(response);
            loadingContainer.toggle('hide');
        }

        $.post(url, dataString, success, 'json');
    })

    $('#sortable').on('sortstop', function (event, ui) {

        let export_array = [];

        let url = $('#sortable').data('route');

        $('.ui-state-default').each(function (index, element) {
            let question = {};
            question.guide_evaluation_type_question_id = element.getAttribute('data-guide-evaluation-type-question-id');
            question.sort = index + 1;

            export_array.push(question);
        });

        let data = {
            data: export_array
        };

        let dataString = decodeURIComponent($.param(data))

        function success(response) {
            if (response.reload) {
                window.location = window.location;
            }
        }

        function error(response) {
            console.log(response);
        }

        $.post(url, dataString, success, 'json');
    });

    $(document).on('change', '#guide-evaluation-select', function () {

        let linkURL = new URL($('#new-guide-evaluation-link').attr('href'));

        let guideEvalLinkParams = new URLSearchParams(linkURL.search);

        if ($(this).val() !== '') {
            guideEvalLinkParams.set('guide_evaluation_type_id', $(this).val());
            $('#new-guide-evaluation-link-container').removeClass('hide');
        } else {
            guideEvalLinkParams.delete('guide_evaluation_type_id');
            $('#new-guide-evaluation-link-container').addClass('hide');

        }

        $('#new-guide-evaluation-link').attr('href', linkURL.origin + linkURL.pathname + '?' + guideEvalLinkParams.toString());
    });

    $(document).on('change', '#guide_evaluation_summit', function () {
        if (parseInt($(this).val()) === 1) {
            $('#guide_evaluation_summit_yes').removeClass('hide');
            $('#guide_evaluation_summit_no').addClass('hide');
            $('input[name="guide_evaluation[no_summit_explaination]"]').val('');
        } else if (parseInt($(this).val()) === 0) {
            $('#guide_evaluation_summit_yes').addClass('hide');
            $('#guide_evaluation_summit_no').removeClass('hide');
            $('input[name="guide_evaluation[summited_date]"]').val('');
        } else {
            $('#guide_evaluation_summit_yes').addClass('hide');
            $('#guide_evaluation_summit_no').addClass('hide');
        }
    });

    $(document).on('click', '.email-certificate', function (element) {
        element.preventDefault();
        let theElement = $(this)[0];
        let url = theElement.dataset.href;

        // Get inner HTML
        // Change inner HTML to spinner

        function responseCallback(response) {
            console.log(response);
            // End loading spinner
        }

        http.sendAjax(url, 'GET', null, responseCallback, responseCallback);
    });

    $(document).on("click", "#genSendExpGuideCertRpt", function (e) {
        console.log(e)
        e.preventDefault();

        let theElement = $(this)[0];
        let url = theElement.dataset.href;

        function responseCallback(response) {
            let msg = $("<div><div>")
                .addClass("alert alert-success alert-dismissible fade show mt-4")
                .text("Report generating. Check email shortly.")
                .append(
                    $("<button></button>").addClass("close").attr("data-dismiss", "alert").attr("type", "button").attr("aria-label", "Close")
                        .append(
                            $("<i></i>").addClass("fa fa-times")
                        )
                );
            $(e.target).after(msg)
        }

        http.sendAjax(url, 'GET', null, responseCallback, (e) => console.log(e));
    })
}
